"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'Acera',
    'Aeropuerto',
    'Agregado',
    'Alameda',
    'Aldea',
    'Andén',
    'Angosta',
    'Apartado De Correos',
    'Apartamento',
    'Arrabal',
    'Arroyo',
    'Autopista',
    'Autovía',
    'Avenida',
    'Bajada',
    'Barranco',
    'Barriada',
    'Barrio',
    'Bloque',
    'Bulevar',
    'Calle',
    'Callejón',
    'Calzada',
    'Camino Viejo',
    'Camino',
    'Campa',
    'Cañada',
    'Canal',
    'Canellón',
    'Carrer',
    'Carreta',
    'Carretera',
    'Carril',
    'Caserío',
    'Cava',
    'Cavorco',
    'Centro',
    'Comercial',
    'Chalet',
    'Colegio',
    'Colonia',
    'Conjunto',
    'Contrapuerta',
    'Corguiña',
    'Corredera',
    'Corredora',
    'Corregidor',
    'Costanilla',
    'Cuesta',
    'Desconocida',
    'Diputación',
    'Diseminador',
    'Edificio',
    'Entrada',
    'Escalinata',
    'Esquina',
    'Explanada',
    'Extramuros',
    'Extrarradio',
    'Ferrocarril',
    'Finca',
    'Glorieta',
    'Gran Vía',
    'Grupo',
    'Huerta',
    'Jardines',
    'Lado',
    'Lugar',
    'Manzana',
    'Masía',
    'Mediador',
    'Mercado',
    'Monte',
    'Muelle',
    'Municipio',
    'Otros Conceptos',
    'Parcela',
    'Parque',
    'Partida',
    'Pasadizo',
    'Pasador',
    'Pasaje',
    'Paseo',
    'Pasillo',
    'Playa',
    'Plaza',
    'Plazoleta',
    'Plazuela',
    'Poblado',
    'Polígono Industrial',
    'Polígono',
    'Portada',
    'Portal',
    'Portico',
    'Portillo',
    'Portón',
    'Postigo',
    'Postrigo',
    'Prolongación',
    'Puente',
    'Puerta',
    'Quinta',
    'Ramal',
    'Rambla',
    'Regato',
    'Residencial',
    'Ribera',
    'Rincón',
    'Ronda',
    'Rotonda',
    'Salida',
    'Sector',
    'Senda',
    'Solar',
    'Subida',
    'Terrenos',
    'Torrente',
    'Travesía',
    'Urbanización',
    'Vereda',
    'Via Pública',
    'Via',
    'Vial',
];
//# sourceMappingURL=roadTypes.js.map